const Home = () => {
  return (
    <main className="main-content">
      <section className="content-box">
        <div className="content-meta">
          <span className="date">2023년 10월 1일</span>
        </div>
        <h1 className="content-title">Digiocean에 오신 것을 환영합니다!</h1>
        <p className="content-intro">
          Digiocean은 혁신적인 기술과 창의적인 아이디어를 통해 디지털 세상을
          연결합니다.
        </p>
      </section>
    </main>
  );
};

export default Home;
